import * as React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Typography,
    WithStyles
} from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { styles } from "../../OrderDetailsView.styles";
import { useTranslation } from "react-i18next";
import { BlueButton } from "../../../components/Buttons/BlueButton";
import UniversalTable from "../../../components/UniversalTable/UniversalTable";
import { IUniversalTableColumn, IUniversalTableData } from "../../../components/UniversalTable/interfaces";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";

export interface IKaikoPackage {
    id: number;
    name: string;
    numberOfItems: number;
    price: number;
    currency?: string;
}

export interface IKaikoPicingInfoDialogProps extends WithStyles<typeof styles> {
    packages: IKaikoPackage[];    
    isSubscription?: boolean;
}

const KaikoPricingInfoDilogPure: React.FunctionComponent<IKaikoPicingInfoDialogProps> = ({
    classes,
    packages,
    isSubscription
}: IKaikoPicingInfoDialogProps) => {
    const { t } = useTranslation();

    const [openDetails, setOpenDetails] = React.useState(false);

    const columns: IUniversalTableColumn[] = [
        {
            type: "text",
            title: isSubscription ? "Product" : "Package",
            field: "name",
            editable: "onAdd"
        },
        {
            type: "price",
            title: isSubscription ? "Licence fee per month" : "Price per day per exchange*",
            field: "price"
        }
    ];

    return (
        <>
            <IconButton onClick={() => setOpenDetails(true)}>
                <InfoIcon />
            </IconButton>
            <Dialog
                open={openDetails}
                onClose={() => setOpenDetails(false)}
                scroll="paper"
                fullWidth
                maxWidth={"sm"}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    Kaiko pricing info
                    <IconButton
                        aria-label="close"
                        style={{ position: "absolute", right: "1px", top: "1px" }}
                        onClick={() => setOpenDetails(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <UniversalTable columns={columns} data={packages as IUniversalTableData} dense pagingDisabled />
                        <Typography variant="caption">
                            <p>
                                Assets are purchasable in all the quote currencies that each exchange offers.
                            </p>
                            <p>
                                Please note that in case files are missing for certain instruments, this is due to no
                                trades executed for those instruments.
                            </p>
                            {isSubscription ? (
                                <p>
                                    Data from all exchanges is provided the selected asset was traded on, in the
                                    selected time frame.
                                </p>
                            ) : (
                                <p>
                                    * The final price is dependent on <i>the number of days</i>, the availability of the
                                    selected assets per day within the selected date range,<i> the package price</i>,
                                    and <i>the number of selected exchanges</i>.
                                </p>
                            )}
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <BlueButton onClick={() => setOpenDetails(false)}>{t("general.close")}</BlueButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export const KaikoPricingInfoDialog = withStyles(styles)(KaikoPricingInfoDilogPure);
